import type { FormField } from '@elfsight/widget-form-builder/widget';
import type {
  CalculationType,
  DecimalSeparatorType,
  ThousandsSeparatorType
} from '../../../../types';
import { buildFieldIdForField } from './build-fieldId';

export const prepareCalculationsFields = (
  fields: CalculationType[],
  displayedFields: CalculationType[],
  calculations: Record<string, string | undefined>,
  thousandsSeparator?: ThousandsSeparatorType,
  decimalSeparator?: DecimalSeparatorType
): FormField[] =>
  fields.map((field) => {
    const isHiddenByConditional = displayedFields.every(
      (displayedField) => displayedField.id !== field.id
    );

    return {
      ...field,
      type: 'calculation',
      label: field?.name || '',
      fieldID: field?.fieldID || buildFieldIdForField(field),
      value: calculations[field.id],
      hidden: isHiddenByConditional,
      isCalculatorField: true,
      group: 'calculation-results',
      required: false,
      thousandsSeparator,
      decimalSeparator
    };
  });
